<template>
  <TransitionRoot as="template" :show="open">
    <Dialog as="div" class="fixed inset-0 overflow-hidden z-10" @close="$emit('close')">
      <div class="absolute inset-0 overflow-hidden">
        <DialogOverlay class="absolute inset-0"/>

        <div class="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10 sm:pl-16">
          <TransitionChild as="template" enter="transform transition ease-in-out duration-500 sm:duration-700"
                           enter-from="translate-x-full" enter-to="translate-x-0"
                           leave="transform transition ease-in-out duration-500 sm:duration-700"
                           leave-from="translate-x-0" leave-to="translate-x-full">
            <div class="pointer-events-auto w-screen max-w-md">
              <div class="flex h-full flex-col overflow-y-scroll bg-white shadow-xl">
                <div class="bg-secondary-500 py-6 px-4 sm:px-6">
                  <div class="flex items-start justify-between">
                    <DialogTitle class="text-lg font-medium text-white">Notifications</DialogTitle>
                    <div class="ml-3 flex h-7 items-center">
                      <button type="button"
                              class="rounded-md bg-secondary-500 text-gray-400 hover:text-gray-500 focus:ring-0"
                              @click="$emit('close')">
                        <span class="sr-only">Close panel</span>
                        <XIcon class="h-6 w-6" aria-hidden="true"/>
                      </button>
                    </div>
                  </div>
                  <div class="mt-1">
                    <!--                    <p class="text-sm text-gray-100"></p>-->
                  </div>
                </div>
                <!--                <div class="border-b border-gray-200">-->
                <!--                  <div class="px-6">-->
                <!--                    <nav class="-mb-px flex space-x-6" x-descriptions="Tab component">-->
                <!--                      <a v-for="tab in tabs" :key="tab.name" :href="tab.href"-->
                <!--                         :class="[tab.current ? 'border-indigo-500 text-indigo-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300', 'whitespace-nowrap pb-4 px-1 border-b-2 font-medium text-sm']">{{-->
                <!--                          tab.name-->
                <!--                        }}</a>-->
                <!--                    </nav>-->
                <!--                  </div>-->
                <!--                </div>-->


                <div v-if="notifications.length <= 0" class="flex flex-col items-center pt-16">
                  <span class="rounded-full bg-primary inline-block flex-shrink-0">
                    <ThumbUpIcon class="h-16 w-16 p-2 text-gray-50" aria-hidden="true"></ThumbUpIcon>
                  </span>
                  <p class="mt-6 font-semibold text-gray-500">
                    You have no new notifications.
                  </p>
                </div>
                <ul v-else role="list" class="flex-1 divide-y divide-gray-200 overflow-y-auto">
                  <li v-for="notification in notifications" :key="notification.token">
                    <div class="group relative flex py-6 px-5 items-start">
                      <a :href="notification.href" class="-m-1 block flex-1 p-1  w-full">
                        <div class="absolute inset-0 group-hover:bg-gray-50" aria-hidden="true"/>
                        <div class="relative flex min-w-0 flex-1">
                          <span class="relative inline-block flex-shrink-0">
                            <component :is="getNotificationIcon(notification.type)" class="h-7 w-7 text-secondary-500"
                                       aria-hidden="true"></component>
                            <!--                            <span-->
                            <!--                                :class="[notification.status === 'online' ? 'bg-green-400' : 'bg-gray-300', 'absolute top-0 right-0 block h-2.5 w-2.5 rounded-full ring-2 ring-white']"-->
                            <!--                                aria-hidden="true"/>-->
                          </span>
                          <div class="ml-4 w-full">
                            <p class="text-sm font-semibold text-secondary" v-html="notification.title"></p>
                            <p class="text-sm text-gray-700 text-justify pt-1" v-html="notification.message"></p>
                            <p class="text-sm text-gray-500 text-right pt-1 italic">{{
                                timeAgo(notification.createdAt)
                              }}</p>
                          </div>
                        </div>
                      </a>
                      <button type="button"
                              @click="dismissNotification(notification)"
                              class="relative ml-2 inline-block flex-shrink-0 text-left">
                        <XIcon class="h-6 w-6 text-gray-900" aria-hidden="true"></XIcon>
                      </button>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script>
import {
  Dialog,
  DialogOverlay,
  DialogTitle,
  Menu,
  MenuButton,
  MenuItem,
  MenuItems,
  TransitionChild,
  TransitionRoot,
} from '@headlessui/vue'
import {
  ChatAltIcon,
  EmojiHappyIcon,
  ExclamationCircleIcon,
  ThumbUpIcon,
  UserAddIcon,
  XIcon
} from '@heroicons/vue/outline'
import _isString from "lodash/isString";
import {format, register} from "timeago.js";
import jalocaleFunc from "timeago.js/lib/lang/ja";
import {mapGetters} from "vuex";

export default {
  name: "MainNotificationsPanel",
  components: {
    Dialog,
    DialogOverlay,
    DialogTitle,
    Menu,
    MenuButton,
    MenuItem,
    MenuItems,
    TransitionChild,
    TransitionRoot,
    XIcon,
    ExclamationCircleIcon,
    ChatAltIcon,
    EmojiHappyIcon,
    UserAddIcon,
    ThumbUpIcon,
  },
  props: {
    open: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      // notifications: [{
      //   'id': 'Id',
      //   'token': 'Token',
      //   'title': 'Your report is ready!',
      //   'message': 'Your report for Nyctale is ready for view/download. Your report for Nyctale is ready for view/download. ',
      //   'link': 'link',
      //   'seen': false,
      //   'type': 'general',
      //   'background': 'blue',
      //   'icon': 'Bell',
      //   'created_at': '36 min',
      // }, {
      //   'id': 'Id2',
      //   'token': 'Token2',
      //   'title': 'Your report is ready!',
      //   'message': 'Your report for Nyctale is ready for view/download. Your report for Nyctale is ready for view/download. ',
      //   'link': 'link',
      //   'seen': false,
      //   'type': 'user-invitation',
      //   'background': 'blue',
      //   'icon': 'Bell',
      //   'created_at': '36 min',
      // }, {
      //   'id': 'Id2',
      //   'token': 'Token3',
      //   'title': 'Your report is ready! Your report is ready!',
      //   'message': 'Your report for Nyctale is ready for view/download. Your report for Nyctale is ready for view/download. ',
      //   'link': 'link',
      //   'seen': false,
      //   'type': 'user-invitation',
      //   'background': 'blue',
      //   'icon': 'Bell',
      //   'created_at': '36 min',
      // }],

      // _isLoading: false,
      localeToUse: 'en',
    }
  },
  created() {
    if (this.currentMemberProfile.locale === 'ja_JP') {
      register('ja', jalocaleFunc);
      this.localeToUse = 'ja';
    }
  },
  methods: {
    timeAgo(date) {
      return format(date, this.localeToUse);
    },

    getNotificationIcon(type) {
      if (!_isString(type)) {
        return 'ExclamationCircleIcon';
      }

      switch (type) {
        case 'general':
          return 'ChatAltIcon';
        case 'welcome':
          return 'EmojiHappyIcon';
        case 'user-invitation':
          return 'UserAddIcon';
        default:
          return 'ExclamationCircleIcon';
      }

    },
    dismissNotification(notification) {
      notification.seen = true;
      this.$store
          .dispatch('editGlobalNotification', {notification})
          .then(() => this.$store.commit('dismissGlobalNotification', notification));
    }
  },
  computed: {
    notificationCount() {
      return this.$store.state.globalNotifications.length;
    },
    notifications() {
      return this.$store.state.globalNotifications;
    },
    ...mapGetters({
      currentMemberProfile: 'getCurrentMemberProfile',
    }),
  }
}
</script>

<style scoped>

</style>